import { IAppState } from '../common/state';
import { isInRegionSelector } from './isInRegion';
import { configSelector } from './configSelector';

export function isNewbuildingConsultBannerAvailable(state: IAppState) {
  const config = configSelector(state);
  const consultantPhoneEnabledRegions = config.get<number[]>('newbuildingConsultant.phone.enabledRegions') || [];
  const availableInRegion = isInRegionSelector(consultantPhoneEnabledRegions)(state);

  return (
    state.isNewbuildingsOnly &&
    availableInRegion &&
    state.newbuildingConsultant.bannerAvailable &&
    !!config.get<boolean>('webim.accountName')
  );
}
